import { Component } from '@angular/core';
import { DrawerService } from 'src/app/services/drawer.service';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'app-drawer',
  standalone: true,
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.scss'
})
export class DrawerComponent {

  constructor(
    public readonly drawerService: DrawerService,
    public readonly filtersService: FiltersService

  ) { }

}
